import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ListKegiatan = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/kegiatan`
      );
      setData(res.data);
    } catch (err) {
      console.error("Gagal mengambil data kegiatan", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Fungsi untuk mengubah link ke dalam bentuk yang dapat di-embed
  const getEmbedLink = (url) => {
    if (!url) return null;

    // YouTube
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      const videoIdMatch = url.match(/(?:youtu\.be\/|v=)([^\s&]+)/);
      const videoId = videoIdMatch?.[1];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }

    // Google Drive
    if (url.includes("drive.google.com")) {
      const fileIdMatch = url.match(/\/file\/d\/(.*?)\//);
      const fileId = fileIdMatch?.[1];
      return fileId
        ? `https://drive.google.com/file/d/${fileId}/preview`
        : null;
    }

    return null; // fallback
  };

  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {data.map((item) => {
        const hasMedia = item.media && item.media.length > 0;
        const firstMedia = hasMedia ? item.media[0] : null;
        const isImage = firstMedia?.mimetype?.startsWith("image");
        const isVideo = firstMedia?.mimetype?.startsWith("video");
        const embedLink = getEmbedLink(item.link);

        return (
          <div
            key={item._id}
            className="bg-white shadow p-4 rounded cursor-pointer"
            onClick={() => navigate(`/kegiatan/${item._id}`)}
          >
            <h3 className="text-lg font-bold mb-2">{item.judul}</h3>

            {isImage ? (
              <img
                src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${firstMedia.filename}`}
                alt="gambar"
                className="w-full h-48 object-cover mb-2"
              />
            ) : isVideo ? (
              <video
                src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${firstMedia.filename}`}
                controls
                className="w-full h-48 object-cover mb-2 bg-black"
              />
            ) : embedLink ? (
              <iframe
                src={embedLink}
                title="Video Link"
                className="w-full h-48 mb-2 rounded"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            ) : (
              <p className="text-sm text-gray-500 italic">
                Tidak ada media tersedia.
              </p>
            )}

            {item.link && !embedLink && (
              <a
                href={item.link}
                className="text-blue-600 underline"
                target="_blank"
                rel="noreferrer"
              >
                Lihat Link Video
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ListKegiatan;
